import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["children", "closeOnClickOutside", "onClose", "open", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useClickOutside } from '@applyboard/ui-utils';
import { Drawer as MuiDrawer } from '@material-ui/core';
import React, { useCallback, useRef } from 'react';
export function Drawer(_ref) {
  var children = _ref.children,
    _ref$closeOnClickOuts = _ref.closeOnClickOutside,
    closeOnClickOutside = _ref$closeOnClickOuts === void 0 ? false : _ref$closeOnClickOuts,
    onClose = _ref.onClose,
    open = _ref.open,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var drawerRef = useRef();
  var handleClickOutside = useCallback(function (e) {
    if (variant === 'permanent' && closeOnClickOutside && open) {
      onClose(e, 'backdropClick');
    }
  }, [variant, closeOnClickOutside, open]);
  useClickOutside(drawerRef, handleClickOutside);
  return /*#__PURE__*/React.createElement(MuiDrawer, _extends({
    onClose: onClose,
    open: open,
    ref: drawerRef,
    variant: variant
  }, props), children);
}